import { DealernetApi } from "./DealernetApi";
import { AxiosResponse } from "axios";

import axios from "axios";
import { oc } from "ts-optchain";

export class ResourceLibraryService {

  public static async DocumentSearch(params: any){
    const response = await DealernetApi.client().request({
          method: "post",
          url: 'ResourceLibrary/DocumentSearch',
          
          data: params,
        });
     return oc(response as AxiosResponse<any>).data()!;
  }
}

